












































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import GenericAdd from "@/core/Generics/GenericAdd";
import IndicatorModel from '../../../models/indicator/indicator.model';
import IndicatorService from '../../../services/indicator.service';
@Component
export default class IndicatorAdd extends GenericAdd<IndicatorModel> {

  indicatorService:IndicatorService = new IndicatorService();
  subIndicators:Array<IndicatorModel> =  [];
  constructor() {
    super();
    this.controller = "Indicators"
    this.model =  new IndicatorModel;
  }

  created(){
    let item =  new IndicatorModel();
    this.subIndicators.push(item);
  }

  removeIndicator(id:number,index){
     if (id && id !== 0) {
      this.subIndicators.forEach((item: any) => {
        if (item.id === id) item.deleted = true;
      });
    } else this.subIndicators.splice(index, 1);
  }
    saveAll(){
      this.model.indicatorTypeId = this.$route.params.indicatorTypeId as any;
      return this.validate();
  }
  
  cancel(){ this.$router.push(`${this.$router.currentRoute.path.split('/agregar')[0]}`)}

  addSubInidcator(){
    let foundError = false;
     this.subIndicators.forEach((item: IndicatorModel) => {
      if (!item.name || !item.indicadorNo) {
        this.$buefy.toast.open({
          message:
            "Antes de agregar otro campo debe completar los campos que  tiene vacío",
          queue: false,
          duration: 4000,
          type: "is-danger",
          position: "is-top-right",
        });

        foundError = true;
        return;
      }
    });
    if (foundError) {
      foundError = false;
      return;
    }
    let item =  new IndicatorModel();
    this.subIndicators.push(item);
  }
    save(){
      this.model.indicatorTypeId = Number(this.$route.params.indicatorTypeId);
      if(this.model.isCompound){
         this.subIndicators.forEach(x => {
        x.indicatorTypeId = Number(this.$route.params.indicatorTypeId);
      })
        this.subIndicators.push(this.model)
        this.indicatorService.save(this.subIndicators).then(()=>{
          this.cancel();
          this.operationSuccess();
        })

      }
      else{
        this.saveAll();
      }
    }
}
